module.exports = __webpack_public_path__ + "static/media/shipyard_marker_light_blue.59b87afe.svg";